import posNotificationInstance from '../instance'

const createNotificationDevice = (data) => {
	return posNotificationInstance.post('devices', data)
}

export default createNotificationDevice
